import * as React from "react";
import KuikaButton from "../../ui-kit/kuika-button/kuika-button";
import KuikaSvg from "../../ui-kit/kuika-svg/kuika-svg";
import KuikaSmallText from "../../ui-kit/typography/SmallText/SmallText";
import KuikaTextMedium from "../../ui-kit/typography/TextMedium/TextMedium";

interface LibraryEmptyStateProps {
  /** KuikaSvg name (from the common set) for the medallion icon. */
  icon: string;
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

/** Purpose-built empty state for the External Libraries popover — a soft icon medallion, a title,
 *  a one-line explanation, and an optional call to action. */
const LibraryEmptyState: React.FC<LibraryEmptyStateProps> = ({ icon, title, description, actionLabel, onAction }) => (
  <div className="kuika-external-libraries__empty" data-testid="externalLibrariesEmptyState">
    <span className="kuika-external-libraries__empty-icon">
      <KuikaSvg name={icon} width={20} height={20} />
    </span>
    <KuikaTextMedium className="kuika-external-libraries__empty-title">{title}</KuikaTextMedium>
    <KuikaSmallText className="kuika-external-libraries__empty-text">{description}</KuikaSmallText>
    {actionLabel && onAction && (
      <KuikaButton type="secondary" size="sm" onClick={onAction} className="kuika-external-libraries__empty-action">
        {actionLabel}
      </KuikaButton>
    )}
  </div>
);

export default LibraryEmptyState;
